import ShowMoreText from "react-show-more";

export const AllReviews = () => {
  return (
    <div className="row py-5" id="quote">

      <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto fixed-card">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          {/* Optional video (remove if text-only review) */}
          <video
            width="100%"
            height="300px"
            poster="Assets/Images/video/nagpur-01.PNG"
            controls
          >
            <source src="Assets/Images/video/nmc.mp4" type="video/mp4" />
          </video>

          <div className="blockquote-custom-icon bg-golden shadow-sm">
            <i className="fa fa-quote-left text-white"></i>
          </div>

          <p
            className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}
          >
            <span style={{ fontWeight: 'bold' }}>" Public Grievance Management System " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Under tight deadlines and with high expectations, CDAT has delivered
              the Public Grievance Management System both Mobile App and Web
              Application suited to the requirement of Urban Local Body , The
              Citizens of City have given a overwhelming reponse , The app has seen
              30k plus downloads and still counting in very short time , Well Done
              Team CDAT.
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-lg-3 border-top">
            <b className="text-dark">Hon. Tukaram Mundhe </b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Commissioner of NMC</cite>
          </footer>
        </blockquote>
      </div>

 <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <iframe width="100%" height="300px" src="https://www.youtube.com/embed/pW0OdIeWrbk"
            title="Ahmednagar पोलिसांची नागरिकांसाठी &#39;ई-टपाल&#39; प्रणाली, पोलीस अधीक्षक Manoj Patil यांची संकल्पना |Police"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>

          <div className="blockquote-custom-icon bg-golden shadow-sm "><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" ई - टपाल " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Police Department is a internet & intranet base solution for all government functionaries to monitor their Daily Branch, Section and Table wise letter and file movement of their own Office. LFMS is helping for electronic letter inwards, letter movement from one desk to another desk, creation of desk wise files and letter draft for approval, dispatch of letters, desk wise setting due dates and reminders, desk wise queries and report and migration of letters and files from one desk to another desk.
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3 border-top"><b className="text-dark">Hon. Manoj Patil </b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> SP Ahmednagar</cite>
          </footer>

        </blockquote>

      </div>

   

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3  shadow2 rounded">
          <video width="100%" height="300px" poster="Assets/Images/video/cm-01.jpg" controls>
            <source src="Assets/Images/video/amchi mulgi.mp4" type="video/mp4" />
          </video>
          <div className="blockquote-custom-icon bg-golden shadow-sm">
            <i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" AMCHI MULGI - PUBLIC GRIEVANCE" </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Project of the State Health Department has been successfully inaugurated by the Hon. Chief Minister, Maharashtra State.
              The software under the PCPNTD Act – "AMCHI MULGI." This software aims to create a public portal for managing  grievances under the PCPNDT Act, contributing to the state's efforts to address gender-based inequalities
              and promote equity.
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3  border-top">
            <b className="text-dark">Hon. Eknath Shinde</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Chief Minister Maharashtra</cite>
          </footer>
        </blockquote>
        {/* <!-- END --> */}
      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <img src="Assets/Images/video/nhm.jpg" alt="" width="100%" height="300px" />


          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" Nursing Home Registration " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Project of the Public Health Department Govt. of Maharashtra has been successfully inaugurated by the Hon. Chief Minister, Maharashtra State. The Nursing Home Registration application is designed to facilitate the registration process for nursing homes under the Bombay Nursing Home Registration Act of 1949 and the Maharashtra Nursing Home Registration (Amendment) Regulation Rules, the application allows applicants to request new licenses, as well as renew existing licenses for clinical establishments for nursing homes.
              The system allows applicants to submit detailed information, track application status through various approval stages, and access role-specific dashboards. It also features area-based routing, automatically directing applications to the appropriate inspection officer based on the region type (e.g., Municipal Council, Corporation, Rural, or Cantonment).
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3 border-top">
            <b className="text-dark">Hon. Eknath Shinde</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Chief Minister Maharashtra</cite>
          </footer>
        </blockquote>
        {/* <!-- END --> */}
      </div>


      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/lfmsPhoto.png" alt="" width="100%" height="300px" />

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" Letter and File Management System " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Designed and Developed by CDAT
              has really brought transparency in the Government Domain , The software is very light , easy to operate with
              interactive dashboards, CDAT is a company who understands the government domain, Their expertise empower the
              digital transformation in Government Offices smoothly and efficiently, Good Job Team CDAT.
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark">Project Director</b>
            <cite title="Source Title " style={{ fontSize: '16px' }}> State Agriculture Department </cite>
          </footer>
        </blockquote>

      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/SunrichAgroPhoto.png" alt="" width="100%" height="300px" />
          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" Sunrich Agro Industries " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              We have taken CDAT Pune's Fertilizer Manufacturing Company ERP software. This software is very beneficial for the company. We can manage the entire company on this one software. This software helped us a lot for our company development. It helped us to track and monitor our employee's work in very efficient way. Thank you...!!
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-4 border-top"><b className="text-dark">Ravindra Narsale</b>
            <cite title="Source Title " style={{ fontSize: '16px' }}> Sunrich Agro Industries </cite>
          </footer>

        </blockquote>

      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/milsoPhoto.png" alt="" width="100%" height="300px" />

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="pb-lg-2 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" MILSO " </span> <br />
            Dealing with the team was a pleasant experience. The "MILSO" website launches smoothly because of the CDAT team members' prompt responses, communication, and co-operation. Thank you.
          </p>
          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark"> Director</b>
            <cite title="Source Title " style={{ fontSize: '16px' }} > MILSO</cite>
          </footer>

        </blockquote>

      </div>
    </div>
  )
}